import { css } from '@emotion/react';
import React from 'react';

import { AvailableSpaceKeyType, useSpaceMatchingKey } from '../theme';

type StackProps = {
  children: React.ReactNode;
  className?: string;
  s?: AvailableSpaceKeyType;
  as?: React.ElementType;
  height?: React.CSSProperties['height'];
} & React.AriaAttributes;

export const Stack = ({
  children,
  className,
  s,
  as: Component = 'div',
  height,
  ...ariaAttributes
}: StackProps) => {
  const space = useSpaceMatchingKey(s || 's');

  return (
    <Component
      className={className}
      css={css({
        display: 'grid',
        rowGap: space,
        gridTemplateColumns: 'minmax(0, 1fr)',
        height,
      })}
      {...ariaAttributes}
    >
      {children}
    </Component>
  );
};

export default Stack;
